// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".section[data-v-27428072]{position:relative;z-index:999;background-color:#b9d9eb;height:100vh;width:100vw}.section .text-content[data-v-27428072]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);text-align:center}.section .text-content h1[data-v-27428072]{font:500 normal 144px/173px \"Canela\"}.section .text-content h2[data-v-27428072]{font:500 normal 36px/60px \"Canela\"}.section .text-content p[data-v-27428072]{font:300 normal 16px/30px \"F37Ginger\"}", ""]);
// Exports
module.exports = exports;
